import { useQuery } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { Notification } from 'components/Notifications/types';

export const useGetUnreadNotifications = () =>
    useQuery({
        queryKey: ['unread_notifications'],

        queryFn: async () => {
            const response = await RQAPICallWithData<Notification[]>({
                endpoint: 'notifications/unread',
                method: 'GET',
            });
            return response.content.data;
        },
    });
